export type DashboardCacheDiagnosticEvent =
  | 'write_function_entered'
  | 'session_available'
  | 'user_key_available'
  | 'storage_available'
  | 'set_item_attempted'
  | 'set_item_result'
  | 'post_write_key_exists'
  | 'write_attempted'
  | 'write_success'
  | 'write_failure'
  | 'read_found'
  | 'read_not_found'
  | 'parse_success'
  | 'parse_failure'
  | 'storage_available'
  | 'storage_unavailable'
  | 'missing_data'
  | 'validation_version'
  | 'validation_ttl'
  | 'validation_user_key'
  | 'validation_payload';

const DEBUG_QUERY_FLAG = 'vaniaDebugDashboardCache';

function isEnabled(): boolean {
  try {
    return new URLSearchParams(window.location.search).get(DEBUG_QUERY_FLAG) === '1';
  } catch {
    return false;
  }
}

export function reportDashboardCacheDiagnostic(
  event: DashboardCacheDiagnosticEvent,
  value: boolean | string = true,
): void {
  try {
    if (isEnabled()) {
      console.debug(`[dashboard-cache] ${event}=${value}`);
    }
  } catch {
    // Diagnostics must never affect cache or application behavior.
  }
}

export function getDashboardCacheErrorCategory(error: unknown): string {
  if (error instanceof Error && error.name) {
    return error.name;
  }
  return 'unknown';
}
